import "./App.css";
import Hero from "./sections/Hero";
import AboutUs from "./sections/AboutUs";
import Footer from "./sections/Footer";
import OurTeam from "./sections/OurTeam";
import MemberProfile from "./sections/MemberProfile";
import teamMembers from "./sections/teamData";

function HomePage() {
  return (
    <div className="page-content">
      <Hero></Hero>
      <AboutUs></AboutUs>
      <OurTeam></OurTeam>
      <Footer></Footer>
    </div>
  );
}

function App() {
  const path = window.location.pathname.toLowerCase();
  const memberMatch = path.match(/^\/team\/([a-z0-9-]+)\/?$/);
  const member = memberMatch
    ? teamMembers.find(
        (person) => person.slug.toLowerCase() === memberMatch[1].toLowerCase()
      )
    : null;

  if (memberMatch) {
    return (
      <div className="App">
        <div className="page-content">
          <MemberProfile member={member}></MemberProfile>
          <Footer></Footer>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <HomePage></HomePage>
    </div>
  );
}

export default App;
